export var INIT_TODAYS_RATE = 'INIT_TODAYS_RATE';
export var RECEIVE_RATES = 'RECEIVE_RATES';